import { type ComponentPropsWithoutRef, type FC } from 'react'

type Props = ComponentPropsWithoutRef<'table'>

/**
 * 基本的なTableコンポーネント
 * - 最小限のスタイルを定義
 */
export const BasicTable: FC<Props> = ({ children, ...props }) => {
  return <table {...props}>{children}</table>
}
